import React from "react";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const navigate = useNavigate();

  const handleSignInClick = () => {
    navigate("/memberSignin"); // Redirect to the MemberSignIn page
  };

  const handleScheduleClick = () => {
    window.open(
      "https://event.insolindia.com/events.html",
      "_blank"
    );
  };

  const handleBecomeMemberClick = () => {
    window.open("https://www.insolindia.com/become-member.php", "_blank");
  };

  return (
    <div className="bghome">
      <button style={styles.button} onClick={handleSignInClick}>
        Sign In
      </button>
      <button style={styles.button} onClick={handleScheduleClick}>
        Programme Schedule
      </button>
      <button style={styles.button} onClick={handleBecomeMemberClick}>
        Become a Member
      </button>
    </div>
  );
};

// Inline styles for the container and buttons
const styles = {
  button: {
    width: "200px",
    padding: "10px 20px",
    margin: "10px",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#fff",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textAlign: "center",
  },
};

export default HomePage;
